const graficoInformeRendimentos = (context, dados) => {
  let anosData = {};

  // Agrupa os dados por ano
  dados.forEach(el => {
    const ano = el.ANO;
    if (!anosData[ano]) {
      anosData[ano] = {
        totalRendimentos: 0,
        imposto: 0,
        contribuicao: 0
      };
    }

    if (el.CD_ITEM_DIRF == "1") {
      anosData[ano].totalRendimentos += parseFloat(el.VALOR);
    } else if (el.CD_ITEM_DIRF == "5") {
      anosData[ano].imposto += parseFloat(el.VALOR);
    } else if (el.CD_ITEM_DIRF == "2") {
      anosData[ano].contribuicao += parseFloat(el.VALOR);
    }
  });

  // Prepara os dados para o gráfico
  const anos = Object.keys(anosData).sort();
  const totalRendimentos = [];
  const imposto = [];
  const contribuicao = [];
  anos.forEach(ano => {
    totalRendimentos.push(anosData[ano].totalRendimentos);
    imposto.push(anosData[ano].imposto);
    contribuicao.push(anosData[ano].contribuicao);
  });

  return {
    agrupados: {
      series: [
        {
          name: 'Total dos Rendimentos (inclusive férias)',
          data: totalRendimentos
        },
        {
          name: 'Contribuição Previdenciária Oficial',
          data: contribuicao
        },
        {
          name: 'Imposto sobre a renda retido na fonte',
          data: imposto
        }
      ],
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
          stacked: true,
          events: {
            dataPointSelection: function (chartContext, seriesIndex, config) {
              let aux = anos[config.dataPointIndex]
              context.passaDados(aux);
            },
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '100%',
            endingShape: 'rounded',

          },
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'middle',
          style: {
            fontSize: '15px',
            color: ['#fff']
          },
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          },
        },
        stroke: {
          show: true,
          width: 30,
          colors: ['transparent']
        },
        colors: ['#34c38f', '#f46a6a', '#556ee6'],
        xaxis: {
          categories: anos,
        },

        grid: {
          borderColor: '#f1f1f1',
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          theme: 'dark',
          y: {
            formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            },
          }
        },
      }
    },
    data: {
      seriestotalRendimentos: [{
        name: 'Total dos Rendimentos',
        data: totalRendimentos
      }],
      chartOptionstotalRendimentos: {
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function (chartContext, seriesIndex, config) {
              let aux = anos[config.dataPointIndex]
              context.passaDados(aux);
            },
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          },
          offsetY: -22,
          style: {
            fontSize: '12px',
          }
        },
        colors: ['#34c38f'],
        xaxis: {
          categories: anos,
          position: 'bottom',
        },

        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            },
          }
        },
      },
      seriesImposto: [{
        name: 'Imposto',
        data: imposto
      }],
      chartOptionsImposto: {
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function (chartContext, seriesIndex, config) {
              let aux = anos[config.dataPointIndex]
              context.passaDados(aux);
            },
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          },
          offsetY: -22,
          style: {
            fontSize: '12px',
          }
        },
        colors: ['#556ee6'],
        xaxis: {
          categories: anos,
          position: 'bottom',
        },

        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            },
          }
        },
      },
      seriesContribuicao: [{
        name: 'Total dos Rendimentos',
        data: contribuicao
      }],
      chartOptionsContribuicao: {
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function (chartContext, seriesIndex, config) {
              let aux = anos[config.dataPointIndex]
              context.passaDados(aux);
            },
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          },
          offsetY: -22,
          style: {
            fontSize: '12px',
          }
        },
        colors: ['#f46a6a'],
        xaxis: {
          categories: anos,
          position: 'bottom',
        },

        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            },
          }
        },
      },
    }
  };
};
export { graficoInformeRendimentos };